

import {
  computed, defineComponent, PropType, toRefs
} from 'vue';
import { ExternalProjectListEntry } from '@/models/Project';
import useUser from '@/mixins/useUser';
import ClosedStatusIcon from '@/assets/svg/checkmark_s3.svg?inline';

export default defineComponent({
  name: 'ProjectListItemOpenState',
  props: {
    status: {
      type: String as PropType<ExternalProjectListEntry['status']>,
      required: true,
    }
  },
  setup(props) {
    const { status } = toRefs(props);
    const { tUserFallback: t } = useUser('self');
    const isClosed = computed(() => status.value !== 'ACTIVE' && status.value !== 'HOLD');

    const statusIndicatorClass = computed(() => {
      switch (status.value) {
        case 'ACTIVE':
          return 'bc-project-list-item-open-state--open';
        case 'HOLD':
          return 'bc-project-list-item-open-state--hold';
        default:
          return 'bc-project-list-item-open-state--closed';
      }
    });

    return {
      ClosedStatusIcon,
      isClosed,
      t,
      statusIndicatorClass
    };
  }
});

